export default __webpack_public_path__ + "static/media/ppt.c27e55ff.png";